import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  tenant: ITenant;
}

const TenantAccessButton: React.FC<IParams> = ({ tenant }) => {
  const rootStore = useContext(RootStoreContext);
  const { isOfflineModeEnabled } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  const linkClassName = "btn loginButton btn-block btn-lg btn-dark text-white font-weight-bold";
  const label = t("tenant_login_btn");

  return (
    <>
      {isOfflineModeEnabled ? (
        // <Link to={ tenant.redirectDOC ? `${tenant.path}/repository`: `${tenant.path}/meetings`} className={linkClassName}>{label}</Link>
        <Link to={`${tenant.path}/meetings`} className={linkClassName}>{label}</Link>
      ) : (
        <a href={  tenant.redirectDOC ? `/player${tenant.path}/repository` : `/player${tenant.path}/meetings` } className={linkClassName}>{label}</a>
      )}
    </>
  );
};

export default observer(TenantAccessButton);
